// extracted by mini-css-extract-plugin
module.exports = {"contentTitle":"styles_contentTitle__4t3Y4"};